module.exports = __webpack_public_path__ + "img/banner_10.628b4f5f.jpg";